<h1 mat-dialog-title>New Appointment</h1>
<mat-dialog-content [class.saving]="saving">
  @if (saving) {
    <xui-loading-spinner></xui-loading-spinner>
  }
  @if (form !== null && !saving) {
    <form class="new-appointment-form" [formGroup]="form" [class.form-validated]="validate">
      <mat-form-field appearance="fill" class="w-100 compact mat-background-reset mb-3" [style.background-color]="selectedType?.displayStyle" subscriptSizing="dynamic">
        <mat-label>Appointment Type</mat-label>
        <mat-select [formControlName]="'appointmentType'" required>
          @for (type of appointmentTypes; track type) {
            <mat-option class="py-0" [value]="type.id" [style.background-color]="type.displayStyle">{{type.title}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Title</mat-label>
        <input matInput [formControlName]="'title'" type="text" maxlength="100"/>
      </mat-form-field>
      @if (selectedType?.isPatientAppointment) {
        <div class="w-100">
          @if (!hasPatient) {
            <xui-mat-autocomplete placeholder="Search Patients" class="w-100" [searchObservable]="searchPatients"
              [addItemCardText]="'Click here to add a new patient.'" [alwaysShowAddCard]="true"
            [displayResultsCardTemplate]='patientsTemplate' (addNewItem)="addNewPatient()" (itemSelected)="patientSelected($event)"></xui-mat-autocomplete>
          }
          <ng-template #patientsTemplate let-patient="result" let-queryText="queryText">
            <div class="patients-search-results container">
              <div class="row">
                @if (!practiceSettings?.useFileNumberAsPatientProfileId) {
                  <div class="col-sm-4 p-1" [innerHtml]="patient.profileId.toString().padStart(4, '0') | textHighlight: queryText"></div>
                }
                @if (practiceSettings?.useFileNumberAsPatientProfileId) {
                  <div class="col-sm-4 p-1" [innerHtml]="patient.fileNumber | textHighlight: queryText"></div>
                }
                <div class="col-sm-8 p-1" [innerHtml]="patient.displayName | textHighlight: queryText"></div>
              </div>
              <div class="row">
                <div class="col-sm-4 p-1" [innerHtml]="patient.cell | textHighlight: queryText"></div>
                <div class="col-sm-4 p-1" [innerHtml]="patient.tel | textHighlight: queryText"></div>
                <div class="col-sm-4 p-1" [innerHtml]="patient.identityNumber | textHighlight: queryText"></div>
              </div>
            </div>
          </ng-template>
          @if (allowPatientAppointmentsWithoutPatient && !hasPatientMetaData && !hasPatient) {
            <div class="w-100 mb-3">
              You can book an appointment without creating a patient profile.
              <button mat-stroked-button color="primary" (click)="openMetaForm()">Add Patient Details</button>
            </div>
          }
          @if (allowPatientAppointmentsWithoutPatient && hasPatientMetaData && !hasPatient) {
            <div class="w-100 mb-3">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Temporary Patient Details</mat-label>
                <input readonly matInput value=" {{appointmentMetaPatientData.name}} - {{appointmentMetaPatientData.cell ?? appointmentMetaPatientData.email ?? ''}}">
                <button mat-icon-button matSuffix *xuiPermissionRequired="'Clinical.Patients.Write'" (click)="addNewPatient()">
                  <mat-icon>library_add</mat-icon>
                </button>
              </mat-form-field>
            </div>
          }
          @if (hasPatient) {
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Selected Patient</mat-label>
              <input readonly matInput [value]="(patient?.profileId ? patient.profileId.toString().padStart(4, '0') : '') + ' - ' + (patient?.displayName || '')">
              <button mat-icon-button matSuffix (click)="clearPatient()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          }
        </div>
      }
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Start Date & Time</mat-label>
        <xui-mat-datetime [formControlName]="'date'" #datetime="matDatetime" />
        <button mat-icon-button matSuffix (click)="datetime.togglePicker()">
          <mat-icon>today</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>End Date & Time</mat-label>
        <xui-mat-datetime [formControlName]="'endDate'" #endDatetime="matDatetime" />
        <button mat-icon-button matSuffix (click)="endDatetime.togglePicker()">
          <mat-icon>today</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Booking Comment</mat-label>
        <textarea matInput [formControlName]="'comment'" maxlength="250"></textarea>
      </mat-form-field>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="mx-3 mb-2">
  <button mat-button (click)="close()" [disabled]="saving">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="saving">Save</button>
</mat-dialog-actions>
